const QueryStringBuilder = (query: any) => {
    let queryString = "";
    Object.keys(query).map((prop: any, index: number) => {
        if (query[prop] || typeof(query[prop]) == 'boolean') {
            if (Array.isArray(query[prop])) {
                queryString += query[prop].map((item: any) => `${prop}=${item}&`).join('')
            }
            else {
                queryString += `${prop}=${query[prop]}&`;
            }

        }
    });

    queryString = queryString.substring(0, queryString.length - 1);

    return queryString
}

export default QueryStringBuilder;